import { createReducer, on } from '@ngrx/store';
import { BoardType } from '../interfaces/helper.interface';
import { MakeChangeActions } from '../actions/cir.actions';
import { IrisWorkspaceType } from '../../../../data-access/setup/types/iris-workspace.type';

export interface MakeChangeState {
  workspaceTypes: IrisWorkspaceType[];
  reviewLocations: BoardType[];
  workspaceType: BoardType | undefined;
  reviewLocationtype: string;
  sites: string[];
  sitesData:
    | {
        total: number;
        data: any[];
        statuses: { label: string; value: string }[];
      }
    | undefined;
  study: string;
  studyName: string;
  site: string;
  loading: boolean;
  error: string | null;
  totalSites: number;
  studyHasAccess: boolean;
  siteLoaded: boolean;
}

const initialState: MakeChangeState = {
  error: null,
  loading: false,
  reviewLocations: [],
  reviewLocationtype: '',
  site: '',
  sites: [],
  sitesData: undefined,
  study: '',
  studyName: '',
  workspaceType: undefined,
  workspaceTypes: [],
  totalSites: 0,
  studyHasAccess: false,
  siteLoaded: false,
};

export const CIRREDUCER = createReducer(
  initialState,
  on(MakeChangeActions.loadWorkspaceTypes, (state) => ({
    ...state,
    loading: true,
  })),
  on(
    MakeChangeActions.loadWorkspaceTypesSuccess,
    (state, { workspaceTypes }) => ({
      ...state,
      workspaceTypes,
      loading: false,
    }),
  ),
  on(MakeChangeActions.loadReviewLocations, (state) => ({
    ...state,
    loading: true,
  })),
  on(
    MakeChangeActions.loadReviewLocationsSuccess,
    (state, { reviewLocations }) => ({
      ...state,
      loading: false,
      reviewLocations,
    }),
  ),
  on(MakeChangeActions.loadSites, (state) => ({
    ...state,
    loading: true,
  })),
  on(MakeChangeActions.loadSitesSuccess, (state, { sites }) => ({
    ...state,
    loading: false,
    sitesData: sites,
  })),
  on(MakeChangeActions.storeStudyId, (state, { study }) => ({
    ...state,
    study,
  })),
  on(MakeChangeActions.storeStudyName, (state, { studyName }) => ({
    ...state,
    studyName,
  })),
  on(MakeChangeActions.storeSingleSite, (state, { site }) => ({
    ...state,
    site,
  })),
  on(MakeChangeActions.storeSingleSite, (state, { site }) => ({
    ...state,
    site,
  })),
  on(MakeChangeActions.storeWorkspaceType, (state, { workspaceType }) => ({
    ...state,
    workspaceType,
  })),
  on(MakeChangeActions.clearAll, (state) => ({
    ...state,
    ...initialState,
  })),

  on(
    MakeChangeActions.storeReviewLocationType,
    (state, { reviewLocationtype }) => ({
      ...state,
      reviewLocationtype,
    }),
  ),
  on(MakeChangeActions.storeStudyAccess, (state, { has_access }) => ({
    ...state,
    studyHasAccess: has_access,
  })),

  on(MakeChangeActions.setTotalSites, (state, { totalSites }) => ({
    ...state,
    totalSites: totalSites,
  })),

  on(MakeChangeActions.setSiteLoaded, (state, { siteLoaded }) => ({
    ...state,
    siteLoaded: siteLoaded,
  })),
);
